<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div>
      Freundschaftsanfrage
    </div>
    <div
      v-if="hasErrors"
      v-for="(error, index) in attributeErrors"
      :key="index"
      class="invalid-feedback"
    >
      <div v-for="e in error" :key="e">
        {{ e }}
      </div>
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attributeErrors: {
      type: Array
    },
    index: {
      type: Number
    }
  },
  computed: {
    hasErrors() {
      return this.attributeErrors !== null && this.attributeErrors.length !== 0;
    },
  }
}
</script>
